import { ReactNode, useRef } from "react";
import { Box } from "@chakra-ui/react";

type FileUploadProps = {
  onChange?: (e: HTMLInputElement | null) => void;
  accept?: string;
  multiple?: boolean;
  children?: ReactNode;
};

const FileUpload = (props: FileUploadProps) => {
  const { onChange, accept, multiple, children } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => inputRef.current?.click();

  return (
    <Box onClick={handleClick} w="fit-content">
      <input
        type={"file"}
        multiple={multiple || false}
        hidden
        accept={accept}
        onChange={(e) => {
          if (!e.target.files) return;
          onChange && onChange(e.target);
          e.target.value = "";
        }}
        ref={(e) => {
          inputRef.current = e;
        }}
      />
      {children}
    </Box>
  );
};

export default FileUpload;
